import * as React from "react"
import {DateRangePickerSeeker} from "@ui-seeker/core"

import {dateRange} from "../@signals"


export default function UnmatchedNewProductsDateRangeSelect({ ...props }) {

    return <DateRangePickerSeeker
        value={dateRange.value}
        label="Date Range"
        onChange={e => dateRange.value = e}
        {...props}
    />
}

